import {createEntityAdapter, createSlice} from "@reduxjs/toolkit";

const prescriptionsAdapter = createEntityAdapter();

const initialState = prescriptionsAdapter?.getInitialState({
    prescriptionsLoadingStatus: 'idle'
});

const prescriptionsSlice = createSlice( // starting a function for creating a prescriptionsSlice
    {
        name: 'prescriptions', // 1. arg: name space for the slice (unique)
        initialState, //2. arg:
        reducers: { // place for actionCreators (left)  and corresponding actions (right) - immer for immutability
            prescriptionsFetching: state => {state.prescriptionsLoadingStatus = 'loading';},
            prescriptionsFetched: (state, action) => {
                state.prescriptionsLoadingStatus = 'idle';
                prescriptionsAdapter?.setAll(state, action?.payload); // war: state.prescriptions = action.payload;
            },
            prescriptionsFetchingError: state => {state.prescriptionsLoadingStatus = 'error';}
        }
    }
);

// tailor the slice in actions and reducer for putting it into the main function for creating the store
const {reducer} = prescriptionsSlice;

export default reducer;